export default __webpack_public_path__ + "bc956223c7374cd2d5b5cc253b600fa5.svg";